<template>
  <v-container class="max-width-1200">

    <v-row>
      <v-col class="pa-0">
        <h3 class="pt-4">{{ $t("study.rubinCool.01.title")}}</h3>
        <p>
          {{ $t("study.rubinCool.01.text.01")}}
        </p>
        <p>
          {{ $t("study.rubinCool.01.text.02")}}
        </p>
        <p>
          {{ $t("study.rubinCool.01.text.03")}}
        </p>
        <p>
          {{ $t("study.rubinCool.01.text.04")}}
        </p>
        <p>
          {{ $t("study.rubinCool.01.text.05")}}
        </p>

        <v-row>
          <v-col xs="12" class="mb-4 text-left font-size-xs">
            <v-data-table
              :headers="headers"
              :items="items"
              hide-default-footer
              disable-filtering
              disable-pagination
              disable-sort
              class="elevation-1">
              <template v-slot:item.param="{ item }">
                {{ $t(item.param) }}
              </template>
              <template v-slot:item.home="{ item }">
                {{ $t(item.home) }}
              </template>
              <template v-slot:item.itRoom="{ item }">
                {{ $t(item.itRoom) }}
              </template>
            </v-data-table>
          </v-col>
        </v-row>

        <p>
          {{ $t("study.rubinCool.01.text.06")}}
        </p>

        <h4 class="pt-4">{{ $t("study.rubinCool.01.01.title")}}</h4>
        <p>
          {{ $t("study.rubinCool.01.01.text.01")}}
        </p>
        <p>
          {{ $t("study.rubinCool.01.01.text.02")}}
        </p>

        <h4 class="pt-4">{{ $t("study.rubinCool.01.02.title")}}</h4>
        <p v-html="parseHtml($t('study.rubinCool.01.02.text.01'))"></p>

        <h4 class="pt-4">{{ $t("study.rubinCool.01.03.title")}}</h4>
        <p v-html="parseHtml($t('study.rubinCool.01.03.text.01'))"></p>

        <h3 class="pt-4">{{ $t("study.rubinCool.02.title") }}</h3>
        <p>
          {{ $t("study.rubinCool.02.text.01") }}
        </p>
        <p>
          {{ $t("study.rubinCool.02.text.02") }}
        </p>
        <p>
          {{ $t("study.rubinCool.02.text.03") }}
        </p>
        <p>
          {{ $t("study.rubinCool.02.text.04") }}
        </p>
        <p>
          {{ $t("study.rubinCool.02.text.05") }}
        </p>

        <h3 class="pt-4">{{ $t("study.rubinCool.03.title") }}</h3>
        <p v-html="parseHtml($t('study.rubinCool.03.text.01'))"></p>
        <h4 class="pt-4">{{ $t("study.rubinCool.03.02.title") }}</h4>
        <p>
          {{ $t("study.rubinCool.03.02.text.01") }}
        </p>
        <p>
          {{ $t("study.rubinCool.03.02.text.02") }}
        </p>
        <p v-html="parseHtml($t('study.rubinCool.03.02.text.03'))"></p>
        <p>
          {{ $t("study.rubinCool.03.02.text.04") }}
        </p>
        <p>
          {{ $t("study.rubinCool.03.02.text.05") }}
        </p>
        <p>
          {{ $t("study.rubinCool.03.02.text.06") }}
        </p>
        <p>
          {{ $t("study.rubinCool.03.02.text.07") }}
        </p>
        <p>
          {{ $t("study.rubinCool.03.02.text.08") }}
        </p>

        <h3 class="pt-4">{{ $t("study.rubinCool.04.title") }}</h3>
        <p>
          {{ $t("study.rubinCool.04.text.01") }}
        </p>
        <p>
          {{ $t("study.rubinCool.04.text.02") }}
        </p>
        <p>
          {{ $t("study.rubinCool.04.text.03") }}
        </p>
        <p>
          {{ $t("study.rubinCool.04.text.04") }}
        </p>
        <p>
          {{ $t("study.rubinCool.04.text.05") }}
        </p>

        <v-row>
          <v-col xs="12">
            <v-img
              src="@/assets/studies/studies_rubincool_01.png">
            </v-img>
          </v-col>
        </v-row>

        <p v-html="parseHtml($t('study.rubinCool.04.text.06'))"></p>
        <p>
          {{ $t("study.rubinCool.04.text.07") }}
        </p>
        <p>
          {{ $t("study.rubinCool.04.text.08") }}
        </p>
        <p>
          {{ $t("study.rubinCool.04.text.09") }}
        </p>

        <h4 class="pt-4">{{ $t("study.rubinCool.04.01.title") }}</h4>
        <p>
          {{ $t("study.rubinCool.04.01.text.01") }}
        </p>
        <p>
          {{ $t("study.rubinCool.04.01.text.02") }}
        </p>
        <p>
          {{ $t("study.rubinCool.04.01.text.03") }}
        </p>

        <h4 class="pt-4">{{$t("study.rubinCool.04.02.title")}}</h4>
        <p>
          {{$t("study.rubinCool.04.02.text.01")}}
        </p>
        <p>
          <v-row>
            <v-col cols="6" class="py-1">{{$t("study.rubinCool.04.02.text.01.01")}}</v-col><v-col cols="6" class="py-1">40-75%</v-col>
            <v-col cols="6" class="py-1">{{$t("study.rubinCool.04.02.text.01.02")}}</v-col><v-col cols="6" class="py-1">70-90%</v-col>
            <v-col cols="6" class="py-1">{{$t("study.rubinCool.04.02.text.01.03")}}</v-col><v-col cols="6" class="py-1">30%</v-col>
            <v-col cols="6" class="py-1">{{$t("study.rubinCool.04.02.text.01.04")}}</v-col><v-col cols="6" class="py-1">45%</v-col>
            <v-col cols="6" class="py-1">{{$t("study.rubinCool.04.02.text.01.05")}}</v-col><v-col cols="6" class="py-1">15-20 MHUF</v-col>
            <v-col cols="6" class="py-1">{{$t("study.rubinCool.04.02.text.01.06")}}<b></b></v-col><v-col cols="6" class="py-1"><b>135-200M HUF (20-30%)</b></v-col>
            <v-col cols="6" class="py-1">{{$t("study.rubinCool.04.02.text.01.07")}}</v-col><v-col cols="6" class="py-1">{{$t("study.rubinCool.04.02.text.01.07.b")}}</v-col>
          </v-row>
        </p>
        <p>
          {{$t("study.rubinCool.04.02.text.02")}}
        </p>
        <p>
          {{$t("study.rubinCool.04.02.text.03")}}
        </p>

        <h4 class="pt-4">{{$t("study.rubinCool.04.03.title")}}</h4>
        <p v-html="parseHtml($t('study.rubinCool.04.03.text.01'))"></p>

        <h4 class="pt-4">{{$t("study.rubinCool.04.04.title")}}</h4>
        <p>
          {{$t("study.rubinCool.04.04.text.01")}}
        </p>
        <p>
          {{$t("study.rubinCool.04.04.text.02")}}
        </p>
        <p>
          {{$t("study.rubinCool.04.04.text.03")}}
        </p>
        <p v-html="parseHtml($t('study.rubinCool.04.04.text.04'))"></p>
        <p>

        </p>

      </v-col>
    </v-row>


    <!-- <v-row>
      <v-col class="text-end">
        Készítette <span class="primary--text">Ágoston Zoltán</span>
      </v-col>
    </v-row> -->

  </v-container>
</template>

<script>
  import DataComponentBase from '@/commons/DataComponentBase';

  export default {
    name: 'StudiesRubiconBiatorbagy',
    extends: DataComponentBase,

    data() {
      return {
        headers: [
          { text: '',                               value: 'param' },
          { text: this.$i18n.t('study.rubinCool.01.table.h.01'),  value: 'home' },
          { text: this.$i18n.t('study.rubinCool.01.table.h.02'),  value: 'itRoom' },
        ],
        items: [
            {
              param: "study.rubinCool.01.table.01",
              home: "study.rubinCool.01.table.13",
              itRoom: "study.rubinCool.01.table.25",
            },
            {
              param: "study.rubinCool.01.table.02",
              home: "study.rubinCool.01.table.14",
              itRoom: "study.rubinCool.01.table.26",
            },
            {
              param: "study.rubinCool.01.table.03",
              home: "study.rubinCool.01.table.15",
              itRoom: "study.rubinCool.01.table.27",
            },
            {
              param: "study.rubinCool.01.table.04",
              home: "study.rubinCool.01.table.16",
              itRoom: "study.rubinCool.01.table.28",
            },
            {
              param: "study.rubinCool.01.table.05",
              home: "study.rubinCool.01.table.17",
              itRoom: "study.rubinCool.01.table.29",
            },
            {
              param: "study.rubinCool.01.table.06",
              home: "study.rubinCool.01.table.18",
              itRoom: "study.rubinCool.01.table.30",
            },
            {
              param: "study.rubinCool.01.table.07",
              home: "study.rubinCool.01.table.19",
              itRoom: "study.rubinCool.01.table.31",
            },
            {
              param: "study.rubinCool.01.table.08",
              home: "study.rubinCool.01.table.20",
              itRoom: "study.rubinCool.01.table.32",
            },
            {
              param: "study.rubinCool.01.table.09",
              home: "study.rubinCool.01.table.21",
              itRoom: "study.rubinCool.01.table.33",
            },
            {
              param: "study.rubinCool.01.table.10",
              home: "study.rubinCool.01.table.22",
              itRoom: "study.rubinCool.01.table.34",
            },
            {
              param: "study.rubinCool.01.table.11",
              home: "study.rubinCool.01.table.23",
              itRoom: "study.rubinCool.01.table.35",
            },
            {
              param: "study.rubinCool.01.table.12",
              home: "study.rubinCool.01.table.24",
              itRoom: "study.rubinCool.01.table.36",
            },
        ],
      }
    },

    methods: {
      parseHtml(rawText) {
        let parser = new DOMParser();
        let doc = parser.parseFromString(rawText, "text/html");
        return doc.querySelector("body").innerHTML;
      },
    },
  }
</script>
